<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="pre">
<p class="ctfm"><a href="#/eerbauckham0005#rpre">Preface</a></p>
<p class="pf">Some of the material in this book was first presented as lectures that I was invited to give in three institutions in the U.S.: the fourteenth Annual Biblical Studies Lectures, 2003, at Beeson Divinity School, Samford University, Birmingham, Alabama; the Payton Lectures, 2003, at Fuller Theological Seminary, Pasadena, California; and the Derward W. Deere Lectures, 2004, at Golden Gate Baptist Theological Seminary, Mill Valley, California. I am grateful to these institutions for inviting me and to many people, staff and students, who made valuable comments on the lectures and who helped to make my visits a great pleasure.</p>
<p>Much of this book was written during a gradual recuperation from prolonged illness. I believe it could not have been written without the prayers of many who supported me during that period, or without — to use Paul’s phrase (2 Cor 12:9) — God’s grace working as power in weakness.</p>
<p class="patr">R<span class="small">ICHARD</span> B<span class="small">AUCKHAM</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-bauckham-0007.vue?055a1f2e